export function getFreeSeatRemainingCount(product) {
  const count = Number(product?.count || 0);
  const reserved = Number(product?.reserved || 0);
  if (!Number.isFinite(count) || !Number.isFinite(reserved)) {
    return 0;
  }
  return Math.max(count - reserved, 0);
}

export function clampFreeSeatQuantity(quantity, remainingCount) {
  const maxQuantity = Math.max(Number(remainingCount || 0), 0);
  if (maxQuantity <= 0) {
    return 0;
  }

  const parsedQuantity = Number(quantity);
  const nextQuantity = Number.isFinite(parsedQuantity) ? Math.trunc(parsedQuantity) : 1;
  return Math.min(Math.max(nextQuantity, 1), maxQuantity);
}

export function buildFreeSeatSelection(spot, quantity) {
  const selectionCount = Math.max(Math.trunc(Number(quantity || 0)), 0);
  if (!spot?.id || selectionCount <= 0) {
    return [];
  }

  const formatDisplayName = (index) => {
    const seatName = String(spot.name || "");
    const separator = /^[A-Za-z]$/.test(seatName) ? "" : " ";
    return `${seatName}${separator}${index + 1}`;
  };

  return Array.from({ length: selectionCount }, (_, index) => ({
    id: spot.id,
    name: spot.name,
    displayName: formatDisplayName(index),
    clientKey: `free-seat-${spot.id}-${index + 1}`,
  }));
}

export function getSeatDisplayName(seat) {
  return seat?.displayName || seat?.name || "";
}

export function getSeatOptionKey(seat, optionId) {
  return `${seat?.clientKey || seat?.id || "seat"}-${optionId}`;
}

export function isReservationOptionForSeat(option, seat) {
  if (option?.seatKey || seat?.clientKey) {
    return option?.seatKey === seat?.clientKey;
  }
  return option?.spotId === seat?.id;
}

export function isReservationOptionSelected(option, seat, optionId) {
  return (
    isReservationOptionForSeat(option, seat) &&
    option?.optionId === optionId &&
    Number(option?.quantity || 0) > 0
  );
}

export function getReservationOptionSeat(option, seats = []) {
  if (option?.seatKey) {
    const keyedSeat = seats.find((seat) => seat.clientKey === option.seatKey);
    if (keyedSeat) {
      return keyedSeat;
    }
  }
  return seats.find((seat) => seat.id === option?.spotId) || null;
}

export function getReservationOptionSeatLabel(option, seats = []) {
  const seat = getReservationOptionSeat(option, seats);
  return getSeatDisplayName(seat);
}
